<div
    class="d-flex align-items-center rounded-circle"
    [class.text-strong]="commentStatus.count"
    [class.text-muted]="!commentStatus.count"
>
    <wdx-icon
        class="me-1 icon-shift-up"
        iconClass="text-inherit"
        [scale]="1"
        [class.text-danger]="commentStatus.hasIssue"
        icon="comment"
        iconStyle="fas"
    ></wdx-icon>
    @if (longFormat) {
        <h6>
            {{ commentStatus.count }} Comment{{
                commentStatus.count === 1 ? '' : 's'
            }}
        </h6>
    } @else {
        <div class="small" data-cy="lbl-comment-count">
            {{ commentStatus.count }}
        </div>
    }
</div>
